import { render, staticRenderFns } from "./updateBind.vue?vue&type=template&id=b9c06330&scoped=true&"
import script from "./updateBind.vue?vue&type=script&lang=js&"
export * from "./updateBind.vue?vue&type=script&lang=js&"
import style0 from "./updateBind.vue?vue&type=style&index=0&id=b9c06330&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c06330",
  null
  
)

export default component.exports